module.exports = __webpack_public_path__ + "static/media/pb-logo.bf7772d8.png";